import * as React from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { useRecoilValue } from "recoil";
import { textColorState } from "@/lib/store";
import { Drawer, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import MenuContent from "./MenuContent";
import { useRouter } from "next/router";
import styles from "./Menu.module.scss";

type Anchor = "top" | "left" | "bottom" | "right";

// Burger button + left navigation drawer. The drawer paper is transparent so the
// grouped panel (MenuContent) owns the surface, border and safe-area padding.
export default function SwipeableTemporaryDrawer() {
    const [state, setState] = React.useState({
        left: false,
    });

    const sideBarRef = React.useRef<HTMLDivElement>(null);

    const textColor = useRecoilValue(textColorState);

    const { pathname } = useRouter();
    const stockSIPage = pathname === "/s/[exchange]/[ticker]/short-interest";

    const toggleDrawer = (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
        if (event && event.type === "keydown" && ((event as React.KeyboardEvent).key === "Tab" || (event as React.KeyboardEvent).key === "Shift")) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const closeDrawer = () => setState((prev) => ({ ...prev, left: false }));

    const paperProps = {
        sx: {
            background: "transparent",
            backgroundImage: "none",
            boxShadow: "none",
            border: "none",
            overflow: "visible",
        },
    } as const;

    return (
        <div>
            {(["left"] as const).map((anchor) => (
                <React.Fragment key={anchor}>
                    <IconButton aria-label="Open navigation menu" onClick={toggleDrawer(anchor, true)} className={styles.menuButton}>
                        <MenuIcon style={{ color: textColor }} />
                    </IconButton>

                    {stockSIPage ? (
                        <Drawer PaperProps={paperProps} anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)} id="menu" ref={sideBarRef}>
                            <MenuContent onNavigate={closeDrawer} />
                        </Drawer>
                    ) : (
                        <SwipeableDrawer
                            PaperProps={paperProps}
                            anchor={anchor}
                            open={state[anchor]}
                            onClose={toggleDrawer(anchor, false)}
                            onOpen={toggleDrawer(anchor, true)}
                            id="menu"
                            ref={sideBarRef}
                        >
                            <MenuContent onNavigate={closeDrawer} />
                        </SwipeableDrawer>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
}
